import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {phoneNumberById} from '/redux/selector/candidate.selector';

import {FirstMergeScreen} from './FirstMergeScreen';

export const FirstMergeScreenConnected = connect(
  createStructuredSelector({
    phoneNumber: phoneNumberById,
  }),
)(FirstMergeScreen);
